import {Route} from "react-router-dom";
import React from "react";
const BrokerOfferUpload = React.lazy(() => import("./brokerComponents/offers/brokerOffers/BrokerOfferUpload"));
const Administration = React.lazy(() => import("./brokerComponents/administration/Administration"));
const MegaReport = React.lazy(() => import('./components/reports/MegaReport'));
const BrokerSession =  React.lazy(() => import ("./brokerComponents/session/BrokerSession"));
const BrokerOffersForApproval = React.lazy(() => import("./components/offers/BrokerOffersForApproval"));
const OnlineOffers = React.lazy(() => import("./brokerComponents/offers/OnlineOffers"));
const BrokerOffers = React.lazy(() => import("./brokerComponents/offers/brokerOffers/BrokerOffers"));
const BrokerOffer = React.lazy(() => import("./brokerComponents/offers/brokerOffers/BrokerOffer"));
const PredefinedReports = React.lazy(() => import("./components/reports/predefined/PredefinedReports"));
const MonthlyReport = React.lazy(() => import("./components/reports/predefined/MonthlyReport"));
const DailyDealsReport = React.lazy(() => import("./components/reports/predefined/DailyDealsReport"));
const ProtocolsReport = React.lazy(() => import("./components/reports/predefined/ProtocolsReport"));
const RegistryOfficeBrokerReport = React.lazy(() => import("./components/reports/registryOffice/RegistryOfficeBrokerReport"));
const RegistryOfficeBrokerHouseReport = React.lazy(() => import("./components/reports/registryOffice/RegistryOfficeBrokerHouseReport"));
const SessionInfo = React.lazy(() => import("./components/sessions/session/SessionInfo"));
const BrokerHouseReport = React.lazy(() => import("./components/reports/BrokerHouseReport"));
const CurrencyRateReport = React.lazy(() => import("./components/reports/CurrencyRateReport"));
const ContractsReport = React.lazy(() => import("./components/reports/ContractsReport"));
const BrokerReport = React.lazy(() => import("./components/reports/BrokerReport"));
const OldContractsReport = React.lazy(() => import("./components/reports/OldContractsReport"));
const OffersReport = React.lazy(() => import("./components/reports/OffersReport"));
const DealsReport = React.lazy(() => import("./components/reports/DealsReport"));
const OfferContracts = React.lazy(() => import("./components/offers/offerContracts/OfferContracts"));
const OfferTickets = React.lazy(() => import("./components/offers/offerTickets/OfferTickets"));
const OfferDeals = React.lazy(() => import("./components/offers/offerDeals/OfferDeals"));
const GuaranteeDeposits = React.lazy(() => import("./components/accounting/guaranteeDeposits/GuaranteeDeposits"));
const GuaranteeDeposit = React.lazy(() => import("./components/accounting/guaranteeDeposits/GuaranteeDeposit"));
const Accounting = React.lazy(() => import("./components/accounting/accounting/Accounting"));
const Currency = React.lazy(() => import("./components/dictionaries/currencies/Currency"));
const ForgottenPassword = React.lazy(() => import("./components/auth/forgottenPassword/ForgottenPassword"));
const Login = React.lazy(() => import("./components/auth/login/Login"));
const ChangePassword = React.lazy(() => import("./components/auth/changePassword/ChangePassword"));
const Broker = React.lazy(() => import("./components/dictionaries/brokers/Broker"));
const Brokers = React.lazy(() => import("./components/dictionaries/brokers/Brokers"));
const BrokerHouses = React.lazy(() => import("./components/dictionaries/brokerHouses/BrokerHouses"));
const BrokerHouse = React.lazy(() => import("./components/dictionaries/brokerHouses/BrokerHouse"));
const Companies = React.lazy(() => import("./components/dictionaries/companies/Companies"));
const Company = React.lazy(() => import("./components/dictionaries/companies/Company"));
const Good = React.lazy(() => import("./components/dictionaries/commodities/Commodity"));
const Goods = React.lazy(() => import("./components/dictionaries/commodities/Commodities"));
const DeliveryTerm = React.lazy(() => import("./components/dictionaries/deliveryTimes/DeliveryTime"));
const DeliveryTerms = React.lazy(() => import("./components/dictionaries/deliveryTimes/DeliveryTimes"));
const Measurement = React.lazy(() => import("./components/dictionaries/measurements/Measurement"));
const Measurements = React.lazy(() => import("./components/dictionaries/measurements/Measurements"));
const Commissions = React.lazy(() => import("./components/dictionaries/commissions/Commissions"));
const Commission = React.lazy(() => import("./components/dictionaries/commissions/Commission"));
const Currencies = React.lazy(() => import("./components/dictionaries/currencies/Currencies"));
const CpvCode = React.lazy(() => import("./components/dictionaries/cpvCodes/CpvCode"));
const CpvCodes = React.lazy(() => import("./components/dictionaries/cpvCodes/CpvCodes"));
const User = React.lazy(() => import("./components/administration/users/User"));
const Users = React.lazy(() => import('./components/administration/users/Users'));
const Offers = React.lazy(() => import('./components/offers/Offers'));
const Offer = React.lazy(() => import('./components/offers/Offer'));
const Sessions = React.lazy(() => import('./components/sessions/session/Sessions'));
const SessionWrapper = React.lazy(() => import('./components/sessions/session/SessionWrapper'));
const Session = React.lazy(() => import('./components/sessions/session/Session'));
const DemoSession = React.lazy(() => import('./components/sessions/DemoSession'));
const OnlineSessions = React.lazy(() => import('./components/sessions/online/OnlineSessions'));
const OnlineSessionWrapper = React.lazy(() => import('./components/sessions/online/OnlineSessionWrapper'));
const OnlineSession = React.lazy(() => import('./components/sessions/online/OnlineSession'));
const OnlineSessionInfo = React.lazy(() => import('./components/sessions/online/OnlineSessionInfo'));
const BrokersToOnlineOffers = React.lazy(() => import('./components/sessions/online/BrokersToOnlineOffers'));
const NotFound = React.lazy(() => import('./components/404/NotFound'));

export const authRoutes = [
    <Route key={'change-password-route'} path={'/changePassword'} element={<ChangePassword />} />,
    <Route key={'forgotten-password-route'} path={'/forgottenPassword'} element={<ForgottenPassword />} />,
    <Route key={'login-route'} path={'*'} element={<Login />} />,
]

export const routes = [
    // Auth
    <Route key={'users-route'} path={'/administration/users'} element={<Users />} />,
    <Route key={'users-create'} path={'/administration/users/create'} element={<User />} />,
    <Route key={'users-edit'} path={'/administration/users/edit/:userId'} element={<User />} />,

    // Dictionaries
    <Route key={'brokers-route'} path={'/dictionaries/brokers'} element={<Brokers />} />,
    <Route key={'brokers-create'} path={'/dictionaries/brokers/create'} element={<Broker />} />,
    <Route key={'brokers-edit'} path={'/dictionaries/brokers/edit/:brokerId'} element={<Broker />} />,
    <Route key={'broker-houses-route'} path={'/dictionaries/broker-houses'} element={<BrokerHouses />} />,
    <Route key={'broker-houses-create'} path={'/dictionaries/broker-houses/create'} element={<BrokerHouse />} />,
    <Route key={'broker-houses-edit'} path={'/dictionaries/broker-houses/edit/:brokerHouseId'} element={<BrokerHouse />} />,
    <Route key={'company-route'} path={'/dictionaries/companies'} element={<Companies />} />,
    <Route key={'company-create'} path={'/dictionaries/companies/create'} element={<Company />} />,
    <Route key={'company-edit'} path={'/dictionaries/companies/edit/:companyId'} element={<Company />} />,
    <Route key={'commodities-route'} path={'/dictionaries/commodities'} element={<Goods />} />,
    <Route key={'commodities-create'} path={'/dictionaries/commodities/create'} element={<Good />} />,
    <Route key={'commodities-edit'} path={'/dictionaries/commodities/edit/:commodityId'} element={<Good />} />,
    <Route key={'delivery-terms-route'} path={'/dictionaries/delivery-terms'} element={<DeliveryTerms />} />,
    <Route key={'delivery-terms-create'} path={'/dictionaries/delivery-terms/create'} element={<DeliveryTerm />} />,
    <Route key={'delivery-terms-edit'} path={'/dictionaries/delivery-terms/edit/:deliveryTimeId'} element={<DeliveryTerm />} />,
    <Route key={'measurements-route'} path={'/dictionaries/measurements'} element={<Measurements />} />,
    <Route key={'measurements-create'} path={'/dictionaries/measurements/create'} element={<Measurement />} />,
    <Route key={'measurements-edit'} path={'/dictionaries/measurements/edit/:measurementId'} element={<Measurement />} />,
    <Route key={'commissions-route'} path={'/dictionaries/commissions'} element={<Commissions />} />,
    <Route key={'commissions-create'} path={'/dictionaries/commissions/create'} element={<Commission />} />,
    <Route key={'commissions-edit'} path={'/dictionaries/commissions/edit/:commissionId'} element={<Commission />} />,
    <Route key={'currencies-route'} path={'/dictionaries/currencies'} element={<Currencies />} />,
    <Route key={'currencies-edit'} path={'/dictionaries/currencies/edit/:currencyRateId'} element={<Currency />} />,
    // <Route key={'cpvCodes-route'} path={'/dictionaries/cpv-codes'} element={<CpvCodes />} />,
    // <Route key={'cpvCodes-create'} path={'/dictionaries/cpv-codes/create'} element={<CpvCode />} />,
    // <Route key={'cpvCodes-edit'} path={'/dictionaries/cpv-codes/edit/:cpvCodeId'} element={<CpvCode />} />,

    //Accounting
    <Route key={'accounting-route'} path={'/accounting/homeScreen'} element={<Accounting />} />,
    <Route key={'guarantee-deposits-route'} path={'/accounting/guarantee-deposits'} element={<GuaranteeDeposits />} />,
    <Route key={'guarantee-deposits-create'} path={'/accounting/guarantee-deposits/create'} element={<GuaranteeDeposit />} />,
    <Route key={'guarantee-deposits-edit'} path={'/accounting/guarantee-deposits/edit/:guaranteeDepositId'} element={<GuaranteeDeposit />} />,


    // Offers
    <Route key={'offers-route'} path={'/offers/all'} element={<Offers />} />,
    <Route key={'offers-withDeal'} path={'/offers/withDeal'} element={<Offers />} />,
    <Route key={'offers-withTicket'} path={'/offers/withTicket'} element={<Offers />} />,
    <Route key={'offers-withContract'} path={'/offers/withContract'} element={<Offers />} />,
    <Route key={'offers-forApproval'} path={'/offers/forApproval'} element={<BrokerOffersForApproval />} />,
    <Route key={'offers-review'} path={'/offers/forApproval/:brokerOfferId/review'} element={<BrokerOffer />} />,
    <Route key={'offers-create'} path={'/offers/create'} element={<Offer />} />,
    <Route key={'offers-create-urgent'} path={'/offers/create/urgent'} element={<Offer />} />,
    <Route key={'offers-edit'} path={'/offers/:offerId/edit'} element={<Offer />} />,
    <Route key={'offers-deals'} path={'/offers/:offerId/deals'} element={<OfferDeals />} />,
    <Route key={'offers-tickets'} path={'/offers/:offerId/tickets'} element={<OfferTickets />} />,
    <Route key={'offers-contracts'} path={'/offers/:offerId/contracts'} element={<OfferContracts/>} />,

    //Sessions
    <Route key={'sessions-route'} path={'/sessions/info'} element={<Sessions/>} />,
    <Route key={'sessions-edit'} path={'/sessions/edit/:exchangeSessionId'} element={<SessionInfo/>} />,
    <Route key={'sessions-demo'} path={'/sessions/demo'} element={<DemoSession/>} />,
    <Route key={'sessions-session'} path={'/sessions/session/:sessionId'} element={<SessionWrapper/>} >
        <Route key={'sessions-session-route'} path={'/sessions/session/:sessionId/:offerId'} element={<Session />} />
    </Route>,

    //Online Sessions
    <Route key={'online-sessions-route'} path={'/sessions/online'} element={<OnlineSessions/>} />,
    <Route key={'online-sessions-edit'} path={'/sessions/online/edit/:exchangeSessionId'} element={<OnlineSessionInfo/>} />,
    <Route key={'online-session'} path={'/sessions/online/:sessionId'} element={<OnlineSessionWrapper/>} >
        <Route key={'sessions-session-route'} path={'/sessions/online/:sessionId/:offerId'} element={<OnlineSession />} />
    </Route>,
    <Route key={'brokers-to-online-offers'} path={'/sessions/online/brokers-to-online-offers/:exchangeSessionId'} element={<BrokersToOnlineOffers/>} />,


    //Reports
    <Route key={'reports-offers'} path={'/reports/offers'} element={<OffersReport/>} />,
    <Route key={'reports-deals'} path={'/reports/deals'} element={<DealsReport/>} />,
    <Route key={'reports-oldContracts'} path={'/reports/oldContracts'} element={<OldContractsReport/>} />,
    <Route key={'reports-brokerHouses'} path={'/reports/brokerHouses'} element={<BrokerHouseReport/>} />,
    <Route key={'reports-brokers'} path={'/reports/brokers'} element={<BrokerReport/>} />,
    <Route key={'reports-currencyRates'} path={'/reports/currencyRates'} element={<CurrencyRateReport/>} />,
    <Route key={'reports-registryOffice-broker'} path={'/reports/registryOffice/broker'} element={<RegistryOfficeBrokerReport/>} />,
    <Route key={'reports-registryOffice-brokerHouse'} path={'/reports/registryOffice/brokerHouse'} element={<RegistryOfficeBrokerHouseReport/>} />,
    <Route key={'reports-contracts'} path={'/reports/contracts'} element={<ContractsReport />} />,
    //Reports Predefined
    <Route key={'reports-predefined'} path={'/reports/predefined'} element={<PredefinedReports />}>
        <Route key={'reports-predefined-monthly'} path={'/reports/predefined/monthly'} element={<MonthlyReport />} />
        <Route key={'reports-predefined-daily-deals'} path={'/reports/predefined/dailyDeals'} element={<DailyDealsReport />} />
        <Route key={'reports-predefined-protocols'} path={'/reports/predefined/protocols'} element={<ProtocolsReport />} />
    </Route>,
    <Route key={'reports-mega'} path={'/reports/mega'} element={<MegaReport />} />,


    //Not Found
    <Route key={'not-found-route'} path={'*'} element={<NotFound />} />
]

export const brokerRoutes = [
    //Offers
    <Route key={'broker-offers-online'} path={'/broker-offers/online'} element={<OnlineOffers />} />,
    <Route key={'broker-offers'} path={'/broker-offers/all'} element={<BrokerOffers />} />,
    <Route key={'broker-offers-create'} path={'/broker-offers/create'} element={<BrokerOffer />} />,
    <Route key={'broker-offers-upload'} path={'/broker-offers/upload'} element={<BrokerOfferUpload />} />,
    <Route key={'broker-offers-edit'} path={'/broker-offers/edit/:brokerOfferId'} element={<BrokerOffer />} />,
    <Route key={'offers-edit'} path={'/offers/:offerId/edit/readOnly'} element={<Offer />} />,
    <Route key={'offers-deals'} path={'/offers/:offerId/deals/readOnly'} element={<OfferDeals />} />,
    <Route key={'offers-tickets'} path={'/offers/:offerId/tickets/readOnly'} element={<OfferTickets />} />,
    <Route key={'offers-contracts'} path={'/offers/:offerId/contracts/readOnly'} element={<OfferContracts/>} />,


    //Session
    <Route key={'session'} path={'/session'} element={<BrokerSession/>} />,

    //Administration
    <Route key={'administration'} path={'/administration'} element={<Administration/>} />,



    <Route key={'not-found-route'} path={'*'} element={<NotFound />} />
]
